<template>
  <div>{{ user.displayName }}</div>
</template>

<script lang="ts">
//import { addMessage } from '@/services/messages'

export default {
  props: ['index', 'user']
}
</script>

<style></style>
